var utils = {
  formatterTime: (time) => {
    const date = new Date(time)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    // const hour = date.getHours()
    // const minutes = date.getMinutes()
    // const seconds = date.getSeconds()
    // const dateTime = year + '-' + month + '-' + day + ' ' + utils.checkLength(hour) + ':' + utils.checkLength(minutes) + ':' + utils.checkLength(seconds)
    const dateTime = year + '-' + month + '-' + day
    return dateTime
  },
  checkLength: (str) => {
    str = str.toString()
    if (str.length < 2) {
      str = '0' + str
    }
    return str
  },
  cargoStatus: (str) => { //  返回当前的补货状态 1.待处理,2代发货3.已发货,4已完成
    switch (str) {
      case 1:
        return '待处理'
      case 2:
        return '待发货'
      case 3:
        return '已发货'
      case 4:
        return '已完成'
    }
  },
  processMode: (str) => { //  处理方式1立即补货 2 下一单补货
    switch (str) {
      case 1:
        return '立即补货'
      case 2:
        return '下一单补货'
    }
  },
  returnReason: (str) => { //  处理方式1立即补货 2 下一单补货
    switch (str) {
      case 1:
        return '破包'
      case 2:
        return '不合格'
    }
  },
  returnWarehouse: (str) => { //  T退回仓库,F不退回仓库
    switch (str) {
      case 'T':
        return '退回仓库'
      case 'F':
        return '不退回仓库'
    }
  },
  /**
   * presell((byte)1,"预售"),
   * waiting_for_review((byte)2,"等待审核"),
   * audit_failure((byte)3,"审核失败"),
   * wait_for_delivery((byte)4,"等待发货"),
   * wait_for_receiving((byte) 5, "等待收货"), 
   * fulfill((byte) 6, "待开票"),
   * replenishment((byte) 7, "等待补货"), 
   * for_collection((byte) 8, "待收款"),
   * part_collection((byte) 9,"部分收款"),
   * accomplish((byte) 10,"完成");
   */
  orderStatus: (str) => { //  付款方式 1.货到付款，2.款到发货 3，预售部分货款',
    switch (str) {
      case 6:
        return '待开票'
      case 8:
        return '未收款'
      case 9:
        return '部分收款'
      case 10:
        return '已收款'
    }
  },
  paymentType: (str) => {
    switch (str) {
      case 1:
        return '货到付款'
      case 2:
        return '款到发货'
      case 3:
        return '预售部分货款'
    }
  }
}
export default utils